module.exports = __webpack_public_path__ + "static/img/RE4.5aca53f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE4.jpg
// module id = 4qs0
// module chunks = 0